import React, { Component } from 'react';
import '../static/css/bootstrap.min.css'
import '../index.css'
import part_1_image from '../resources/p4_img1.png'
import part_1_number from '../resources/p4_img2.svg'

import part_2_image from '../resources/p4_img3.png'
import part_2_number from '../resources/p4_img4.svg'

import part_3_image from '../resources/p4_img5.png'
import part_3_number from '../resources/p4_img6.svg'


class Section4 extends Component {
  render() {
    return (
      <section id="page_4">
        <div className="container">
          <div className="row">
            <div className="part">

              <div className="col-sm-6 col-xs-12 image_back">
                <div className="img_wrapper">
                  <img src={part_1_image} className="img-responsive left_image" alt='part_1_image' />
                </div>
              </div>

              <div className="col-sm-6 col-xs-12">
                <div className="part_1_number">
                  <img src={part_1_number} className="img-responsive" alt='part_1_number'/>
                </div>
                <div className="content_wrapper_left">
                  <div className="title">
                    進化した豊富な<br />
                    <span className="red_font">コンテンツ。</span>
                  </div>
                  <div className="sub_title">
                    Musioがいれば、すぐに英語のレッスンが始められる。
                  </div>
                  <div className="content">
                    新たに追加されたAcademy Modeでは、「単語」「表現」「会話」をMusioと繰り返し発音練習して学びます。
                    TOEICや英検などの約6,000単語もあり、試験対策が可能。短時間で効果的に英語を定着させ、上達を促します。
                  </div>
                </div>
                <a href="https://blog.themusio.com/2018/05/16/academy-modeについて/">
                  <div className="musio_button text-center" id="button">
                  Academy Modeについてさらに詳しく→
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="part">

              <div className="visible-xs col-xs-12 image_back" id="part2_image_back">
                <div className="img_wrapper">
                  <img src={part_2_image} className="img-responsive right_image" alt='part_2_image'/>
                </div>
              </div>

              <div className="col-sm-6 col-xs-12">
                <div className="part_2_number">
                  <img src={part_2_number} className="img-responsive" alt='part_2_number'/>
                </div>
                <div className="content_wrapper_right">
                  <div className="title">
                    自由自在、あっという間に<br />
                    <span className="red_font">コンテンツ編集。</span>
                  </div>
                  <div className="sub_title">
                    オリジナルコンテンツで授業準備の時間短縮。
                  </div>
                  <div className="content">
                  Academy Modeのコンテンツは、専用ウェブサイトにて入力することで、簡単にコンテンツの追加・削除が可能です。
                    生徒のレベルやカリキュラムに沿った内容をMusioで教えることができます。
                  </div>
                </div>
                <a href="http://blog.themusio.com/2018/05/15/コンテンツ編集機能について/">
                  <div className="musio_button text-center" id="button">
                    コンテンツ編集機能についてさらに詳しく→
                  </div>
                </a>
              </div>

              <div className="hidden-xs">
                <div className="col-sm-6 col-xs-12 image_back" id="part2_image_back">
                  <div className="img_wrapper" >
                    <img src={part_2_image} className="img-responsive right_image" alt='part_2_image'/>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="row">
            <div className="part">

              <div className="col-sm-6 col-xs-12 image_back">
                <div className="img_wrapper">
                  <img src={part_3_image} className="img-responsive left_image" alt='part_3_image'/>
                </div>
              </div>

              <div className="col-sm-6 col-xs-12">
                <div className="part_3_number">
                  <img src={part_3_number} className="img-responsive" alt='part_3_number'/>
                </div>
                <div className="content_wrapper_left">
                  <div className="title">
                    個別にチェック！<br />
                    <span className="red_font">生徒の学習管理機能。</span>
                  </div>
                  <div className="sub_title">
                    授業外でも先生をサポート。
                  </div>
                  <div className="content">
                    さらに、専用ウェブサイトの生徒の学習管理機能では、個々の学習内容や会話履歴を見ることができます。
                    状況に応じた学びの提供に応用が可能。学習状況をまとめ、可視化することで、先生の負担も軽減します。
                  </div>
                </div>
                <a href="http://blog.themusio.com/2018/05/15/生徒の学習管理機能について/">
                  <div className="musio_button text-center" id="button">
                    生徒の学習管理機能についてさらに詳しく→
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

export default Section4;



// WEBPACK FOOTER //
// ./src/sections/Section4.js